export default __webpack_public_path__ + "static/media/0005.9c184359.WAV";